//import { RouteConfig } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/profil',
    name: 'Profil',
    component: () => import('./views/Profil.vue')
  }
]

export default routes
